export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        children:
          "const whTooltips = { colorLinks: true, iconizeLinks: true, renameLinks: true };",
        type: "text/javascript",
      },
      {
        src: "https://wow.zamimg.com/js/tooltips.js",
        type: "text/javascript",
        defer: true,
      },
    ],
  });
});
